import React, { Component } from 'react';

import UserModel from './UserModel';
import RoleModel from './RoleModel';

import { Form, Input, Button, Modal, Transfer } from 'antd';
const FormItem = Form.Item;

class UserChangePasswordForm extends Component {

  state = {
    modalVisible: false,
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      modalVisible: nextProps.modalVisible
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        delete values.secondpassword;
        this.props.onSuccess(this.props.form, values);
      }
    });
  }

  handleValidateSecondPassword(rule, value, cb) {
    let password = this.props.form.getFieldValue('newPassword');

    if (password === value) {
      cb()
    } else {
      cb('Hesla se neshodují!');
    }
  }

  renderForm() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const fullFormItemLayout = {
      labelCol: {
        xs: { span: 0 },
        sm: { span: 0 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
    };

    return (
      <Form onSubmit={this.handleSubmit.bind(this)}>
        <FormItem
          {...formItemLayout}
          label="Stávající heslo" >
          {getFieldDecorator('oldPassword', {
            rules: [{
              type: 'string', message: 'Položka musí obsahovat text!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }, {
              validator: this.handleValidateUsername
            }],
          })(
            <Input type="password" />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Nové heslo" >
          {getFieldDecorator('newPassword', {
            rules: [{
              type: 'string', pattern: new RegExp("^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]))(?=.{6,})"),              
              message: 'Heslo musí obsahovat alespoň 6 znaků, 1 velké písmeno a 1 číslici!'
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }],
          })(
            <Input type="password" />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Nové heslo ještě jednou" >
          {getFieldDecorator('secondNewPassword', {
            rules: [{
              type: 'string', message: 'Položka musí obsahovat text!',
            }, {
              required: true, message: 'Vyplňte prosím tuto položku!',
            }, {
              validator: this.handleValidateSecondPassword.bind(this)
            }],
          })(
            <Input type="password" />
          )}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">Uložit</Button>
        </FormItem>
      </Form>
    );
  }

  render() {
    if (this.props.type && this.props.type === 'modal') {
      return (
        <Modal
          width={800}
          title="Změna hesla"
          visible={this.state.modalVisible}
          onCancel={() => {
            this.props.form.resetFields();
            this.props.onModalCancel();
            this.setState({ modalVisible: false });
          }}
          footer={<p></p>} >
          {this.renderForm()}
        </Modal>
      )
    } else {
      return this.renderForm();
    }
  }
}

const WrappedParkinglocationForm = Form.create()(UserChangePasswordForm);

export default WrappedParkinglocationForm;


// WEBPACK FOOTER //
// ./src/components/UserChangePasswordForm.js